import React, { useState, useEffect } from 'react';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { get } from '../../helpers/api_helper';
import DashboardMetricCard from './metric-card';

function UnpickedMetric(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
    timeOut: 2000,
  };

  const { t } = props;
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const d = await get(`/api/orders/report/unpicked?offset=${props.offset}`);

        setData(d);
      } catch (error) {
        toastr.error(t('Error loading unpicked data'));
      }
    };

    fetchData();
  }, [props.offset]);

  const total = data?.total || 0;
  const picked = data?.picked || 0;
  const routed = data?.routed || 0;
  const pickedPercent = total > 0 ? Math.round((picked / total) * 100) : 0;

  return (
    <DashboardMetricCard
      accent="#f59e0b"
      eyebrow={t('Fulfillment')}
      title={t('Picking Progress')}
      icon="bx bx-package"
      percentage={pickedPercent}
      summary={t('{{count}} picked', { count: picked })}
      details={[
        { label: t('Orders To Pick'), value: total - picked },
        { label: t('Awaiting Route'), value: total - routed },
        { label: t('Active Queue'), value: total },
      ]}
    />
  );
}

UnpickedMetric.defaultProps = {
  offset: 0,
  t: (x) => (x),
};

UnpickedMetric.propTypes = {
  offset: PropTypes.number,
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(UnpickedMetric));
